import React from 'react'
import "./LHSGridContent.css"

function CardOS({
    title="",
    content="",
    lightTheme=true,
    fourBox=false,
    contentHtml=false,
    contentHeight=false
}){
    const paragraphs = content.split('\n').map((paragraph, index) => <p key={index} className={`body-paragraph my-1 mb-3 ${lightTheme?"color-dark" :"color-light"}`}>{paragraph}</p>);
    return(
        <div className={`card-box p-5 w-100`}
            style={lightTheme?{border:"1px solid black"}:{border:"1px solid white"}}
        >
            <div className='d-flex flex-column gap-3 text-center justify-content-center align-items-center h-100'>
                {title && <h5 className={`sub-heading ${lightTheme?"color-dark" :"color-light"} mb-1`}>{title}</h5>}
                {
                    contentHtml?
                    <p className={`body-paragraph ${lightTheme?"color-dark" :"color-light"} ${contentHeight?"":"card-para"}`} dangerouslySetInnerHTML={{__html:content}}></p>
                    :
                    <p className={`body-paragraph ${lightTheme?"color-dark" :"color-light"} card-para`}>{paragraphs}</p>
                }
            </div>
        </div>
    )
}

function LHSGridContent({
    heading="",
    fontDark=true,
    subHeading="",
    cardData=null
}) {
  return (
    <div style={{background:`${fontDark?"white":"black"}`}}>
        <div className={`LHSGridContent-container standard-padding-space ${!fontDark && "left-gradient-upper"}`} >
            <div className='container'>
                <div className='heading-container text-center'>
                    {subHeading && <h5 className={`sub-heading ${fontDark ? "color-dark":"color-light"}`}>{subHeading}</h5>}
                    <h3 className={`body-heading my-4 ${fontDark ? "color-dark":"color-light"}`}>{heading}</h3>
                </div>

                <div className='row gy-4'>
                {
                    cardData &&
                    cardData.map((ele)=>{
                        return(
                                <div className='col-lg-6'>
                                    <CardOS
                                        title={ele.title}
                                        content={ele.content}
                                        lightTheme={fontDark}
                                        contentHtml={true}
                                        contentHeight={true}
                                    />

                                </div>

    )
    })
    }
    </div>

            </div>

        </div>
    </div>
  )
}

export default LHSGridContent